import type {
  BrandConfigurationInput,
  EnvironmentBrandConfigurationInput,
  InvariantBrandConfigurationInput,
} from "./types";

/**
 * @param environmentInput - Environment-specific configuration (origin, airship, authentication)
 * @param invariantInput - Brand-specific invariant configuration (name, theme, i18n, etc.)
 * @returns Complete brand configuration input
 */
export const createBrandConfigurationInput = (
  environmentInput: EnvironmentBrandConfigurationInput,
  invariantInput: InvariantBrandConfigurationInput,
): BrandConfigurationInput => {
  const { authentication: envAuth, ...envRest } = environmentInput;
  const { authentication: invAuth, ...invRest } = invariantInput;

  const baseConfig = {
    ...envRest,
    ...invRest,
    ...(invariantInput.airship || environmentInput.airship
      ? {
          airship: {
            ...invariantInput.airship,
            ...environmentInput.airship,
          },
        }
      : {}),
    featureFlagging: {
      ...invariantInput.featureFlagging,
      ...environmentInput.featureFlagging,
    },
  } as BrandConfigurationInput;

  if (invAuth || envAuth) {
    return {
      ...baseConfig,
      authentication: {
        ...invAuth,
        ...envAuth,
        ...(invAuth?.googleOneTap || envAuth?.googleOneTap
          ? {
              googleOneTap: {
                ...invAuth?.googleOneTap,
                ...envAuth?.googleOneTap,
              },
            }
          : {}),
      },
    } as BrandConfigurationInput;
  }

  return baseConfig;
};
